import { parseLifecycleStatus } from 'new/modules/settings/capsules/domain/capsule.status';
import { ClusterType, type CapsuleDto } from 'new/stores/capsules/capsules.endpoints';

export const NEXLA_CLOUD_VALUE = '__nexla_cloud__';

export interface ClusterOption {
  value: string;
  label: string;
  isDisabled?: boolean;
  disabledMessage?: string;
  isDefault?: boolean;
  clusterType?: ClusterType | string;
  status?: string;
  uid?: string;
  name?: string;
  provider?: string;
  description?: string | null;
}

export function buildClusterOptions(clusters: CapsuleDto[]): ClusterOption[] {
  if (clusters.length <= 1) return [];

  const defaultCluster = clusters.find((c) => c.is_default === true);

  const nexlaCloud: ClusterOption = {
    value: NEXLA_CLOUD_VALUE,
    label: 'Nexla Cloud',
    isDefault: true,
    clusterType: ClusterType.FULL,
    status: 'active',
    name: defaultCluster?.name,
    uid: defaultCluster?.uid,
  };

  const clusterOptions: ClusterOption[] = clusters
    .filter((cluster) => !cluster.is_default)
    .map((cluster) => {
      const lifecycle = parseLifecycleStatus(cluster.status);
      const isActive = lifecycle === 'active';
      const isCapsule = cluster.cluster_type === ClusterType.CAPSULE;
      const clusterOption: ClusterOption = {
        value: String(cluster.id),
        label: isCapsule ? cluster.name : 'Nexla Cloud',
        isDefault: !isCapsule,
        // Intentional: a capsule is selectable even when not yet active. Customers
        // register a capsule and may configure sources against it before the
        // dataplane finishes coming online; the warning icon signals the state.
        // Only non-capsule (secondary cloud) clusters are disabled when inactive.
        isDisabled: !isCapsule && !isActive,
        disabledMessage: !isCapsule && !isActive ? `Cluster is ${lifecycle}` : undefined,
        clusterType: cluster.cluster_type,
        status: cluster.status,
        uid: cluster.uid,
        ...(isCapsule ? {} : { name: cluster.name }),
        provider: cluster.provider,
        description: cluster.description,
      };
      return clusterOption;
    });

  return [nexlaCloud, ...clusterOptions];
}
